var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.546875 9.94922L3.25391 12.6562C3.39062 12.793 3.58203 12.793 3.71875 12.6562L6.42578 9.94922C6.64453 9.73047 6.48047 9.375 6.20703 9.375H4.26562V0.953125C4.26562 0.789062 4.10156 0.625 3.9375 0.625H3.0625C2.87109 0.625 2.73438 0.789062 2.73438 0.953125V9.375H0.765625C0.492188 9.375 0.328125 9.73047 0.546875 9.94922Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowDown);
export default __webpack_public_path__ + "static/media/long-arrow-down.f16e5dbcd03182d30d1317571565b45a.svg";
export { ForwardRef as ReactComponent };